import * as echarts from 'echarts';
import { useEffect, useRef } from 'react';
import { debug } from 'zf-web-infra';
import type { CSSProperties } from 'react';
import type { ChartsProps } from '../types';
import type { InitData } from './types';

/**
 * 初始化Charts组件
 * @param theme
 * @returns
 */
export function useInit(theme: ChartsProps['theme'], style?: CSSProperties): InitData {
  debug.common('useInit', theme);

  const node = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let chart: echarts.ECharts | undefined = undefined;

    if (node.current != null) {
      debug.common('init charts');
      chart = echarts.init(node.current, theme);
    }

    // 支持画面尺寸调整
    const resize = (): void => chart?.resize();
    window.addEventListener('resize', resize);

    // 清理Charts，和Resize事件
    return (): void => {
      debug.common('clean charts');
      chart?.dispose();
      window.removeEventListener('resize', resize);
    };
  }, [theme, style]);

  return { node, getInstance: echarts.getInstanceByDom };
}
